export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const NEW_PROJECT = 'NEW_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';

export const FETCH_TASKS = 'FETCH_TASKS';
export const NEW_TASK = 'NEW_TASK';